import { useMutation } from "@apollo/react-hooks";
import { ChoiceList, Modal } from "@shopify/polaris";
import React, { useCallback, useEffect, useReducer } from "react";
import { MARK_MAPPING_ORDER_LABEL } from "../../../graphql/mutations";
import { arrInvalid, handleError, reducerFn } from "../../../helper";
import useTimeout from "../../../hooks/useTimeout";
import { useToastContext } from "../../shared/ToastContext";

export default function TiktokMarkAsOrderLabel({
    open,
    onClose,
    ids,
    item,
    onCompleted,
}) {
    const [state, setState] = useReducer(reducerFn, {
        selected: ["no"],
    });

    const { setNotify, toggleToast } = useToastContext();

    const [setDelay] = useTimeout();
    const [markMappingOrderlabel, { loading }] = useMutation(
        MARK_MAPPING_ORDER_LABEL,
        {
            onCompleted: () => {
                setNotify({ msg: "Update Mapping Order success", err: false });

                onClose && onClose();
                setDelay(() => {
                    onCompleted && onCompleted();
                }, 2000);
            },
            onError: (err) => {
                setNotify({ msg: handleError(err?.toString()), err: true });
            },
        },
    );

    useEffect(() => {
        const isValid = !!item?.isOrderLabel;

        if (isValid) {
            setState({ selected: ["yes"] });
        }
    }, [item?.isOrderLabel]);

    const handleSubmit = useCallback(() => {
        if (arrInvalid(ids)) return;

        markMappingOrderlabel({
            variables: {
                ids,
                isLabel:
                    state.selected?.length > 0 && state.selected[0] === "yes",
            },
        });
    }, [markMappingOrderlabel, setNotify, toggleToast, ids, state.selected]);

    const handleStateChange = useCallback((selected) => {
        setState({ selected });
    }, []);

    return (
        <Modal
            title="Mark as Tiktok Order Label"
            sectioned
            open={open}
            onClose={onClose}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading: loading,
            }}
        >
            <ChoiceList
                choices={[
                    { value: "no", label: "No" },
                    { value: "yes", label: "Yes" },
                ]}
                selected={state.selected}
                title="Is Order Label"
                onChange={handleStateChange}
            />
        </Modal>
    );
}
